(function () {
	function featuredCollectionSlider() {
		const sliders = document.querySelectorAll(".collection-slider");

		if (sliders.length) {
			sliders.forEach(slider => {
				const id = slider.dataset.sectionId,
					centeredSlide = (slider.dataset.centeredSlide == 'true'),
					centeredSlides = slider.dataset.centeredSlides === 'true' ? true : false,
					columnsMobile = slider.dataset.columnsMobile ? slider.dataset.columnsMobile : 1,
					columnsDesktop = slider.dataset.columnsDesktop ? slider.dataset.columnsDesktop : 2;

				let tabletSlides = 2;
				let proTabletSlides = 2;
				initialSlide = 0;
				if(centeredSlide == true) {
					tabletSlides = 2.4;
					proTabletSlides = 2.8;
					initialSlide = 1;
				}

				const swiperfeaturedCollectionSlider = new Swiper(`.collection-slider-${id}`, {
					loop: true,
					centeredSlides: false,
					initialSlide: 0,
					slidesPerView: columnsMobile,
					slideToClickedSlide: false,
					spaceBetween: 20,
					grabCursor: true,
					longSwipesMs: 500,
					longSwipesRatio: 1,
					navigation: {
						nextEl: `.collection-slider-${id} .slider-arrow-next`,
						prevEl: `.collection-slider-${id} .slider-arrow-prev`,
					},
					breakpoints: {
						750: {
							loop: false,
							// centeredSlides: centeredSlide,
							slidesPerView: tabletSlides
						},
						990: {
							centeredSlides,	
							slidesPerView: proTabletSlides
						},
						1099: {
							loop: true,
							initialSlide: 0,
							centeredSlides,
							slidesPerView: columnsDesktop,
							spaceBetween: 30
						}
					}
				});

				const btnPrev = document.querySelector(`#shopify-section-${id} .featured-collection-header .slider-arrow-prev`);
					const btnNext = document.querySelector(`#shopify-section-${id} .featured-collection-header .slider-arrow-next`);

					if (btnNext) {
						btnNext.addEventListener('click', () => swiperfeaturedCollectionSlider.slideNext());
					}

					if (btnPrev) {
						btnPrev.addEventListener('click', () => swiperfeaturedCollectionSlider.slidePrev());
					}
			});
		}
	}

	document.addEventListener('DOMContentLoaded', featuredCollectionSlider);
	document.addEventListener('shopify:section:load', featuredCollectionSlider);
	window.addEventListener('resize', featuredCollectionSlider);
})();